import '../styles/Navbar.css';
import dev from '../assets/alexuscr.png'
export default function Navbar() {
    return (
        <nav className="nav">
            <div className='nav__links'>
                <div className='nav__logo'>
                    <div>
                        <img src={dev} alt='dev'></img>
                    </div>
                </div>
                <div className='nav__a'>
                    <a href="#experience">Experience</a>
                    <a href="#projects">Projects</a>
                    <a href="#contact">Contact</a>
                </div>
            </div>
        </nav>
    )
}